import React from "react";
import { NavLink } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { LIVE_ACCOUNT_URL, LOGIN_URL } from "../../lib/api";
import { navLinks } from "./navLinks";

export default function DesktopNav() {
    return (
        <>
            <nav className="hidden md:flex items-center gap-8">
                {navLinks.map((l) => (
                    <NavLink
                        key={l.to}
                        to={l.to}
                        end={l.to === "/"}
                        data-testid={`nav-link-${l.label.toLowerCase()}`}
                        className={({ isActive }) =>
                            `text-sm font-semibold transition-colors ${
                                isActive
                                    ? "text-[#A6E3DC]"
                                    : "text-slate-300 hover:text-white"
                            }`
                        }
                    >
                        {l.label}
                    </NavLink>
                ))}
            </nav>

            <div className="hidden md:flex items-center gap-3">
                <a
                    href={LOGIN_URL}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="nav-login-link"
                    className="text-sm font-semibold text-slate-300 hover:text-white"
                >
                    Login
                </a>
                <a
                    href={LIVE_ACCOUNT_URL}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="nav-cta-open-account"
                    className="btn-primary text-sm"
                >
                    Open Account <ArrowUpRight size={16} />
                </a>
            </div>
        </>
    );
}
